import {loadSiprecDailyEstimated, loadSiprecAccumDaily} from '@/api/priv/siprec-daily.api';
import {loadMonthEstimated} from '@/api/priv/siprec-month.api';
import {loadPrevHidroDaily} from '@/api/priv/prev-hidro-daily.api';
import {loadPrevHidroMonth} from '@/api/priv/prev-hidro-month.api';
import {loadHydrologicalMonthlySummary} from '@/api/rest-telemetric/hydrologicalmonthlysummary_zip';
import {loadHydrologicalDailySummary} from '@/api/rest-telemetric/hydrologicaldailysummary_zip';
import {loadHydrologicalHourlySummary} from '@/api/rest-telemetric/hydrologicalhourlysummary_zip';
import {loadHydrologicalObserved} from '@/api/rest-telemetric/hydrologicalreadingsdata_zip';
import {loadOutorgasEfluentesTotal} from '@/api/rest-geobar/outorgas-efluentes-total.api';
import {loadOutorgasEfluentes} from '@/api/rest-geobar/outorgas-efluentes.api';
import {loadUsoSolo} from '@/api/priv/uso-solo.api';
import {loadSiaDetails} from '@/api/rest-forecasts/locationId.api';
import {loadIndicator} from '@/api/priv/indicators.api';
import {loadIndicatorCarga} from '@/api/priv/indicator-carga.api';
import {loadIndicatorErosion} from '@/api/priv/erosion.api';
import {loadAgrotoxico} from '@/api/priv/agrotoxico.api';
import {loadIndicatorBovinesSia} from '@/api/priv/bovines.api';
import {loadCargasUsoDoSolo} from '@/api/priv/cargas.api';
import {loadIndicatorIce} from '@/api/priv/ice.api';
import {loadRestricoesAmbientais} from '@/api/priv/restricoes_ambientais.api';
import {loadSaneparLocations} from '@/api/priv/sanepar_locations.api';
import {
  loadDesmatamentosAnual, loadDesmatamentosMensal, loadDesmatamentosSemestral, loadDesmatamentosTrimestral,
} from '@/api/priv/desmatamentos.api';
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);


const state = {
  accumulatedRainCurrentMonth: [], // reservoir
  accumulatedRainOfTheLastThirtyDays: [], // reservoir
  accumulatedRainCurrentMonthSaic: [], // saic
  accumulatedRainOfTheLastThirtyDaysSaic: [], // saic

  siprecDailyEstimated: [],
  monthEstimated: [],

  prevHidroDaily: [],
  prevHidroMonth: [],

  completeSeries: [],
  grantsEffluentsTotal: [],
  grantsEffluents: [],
  siaDetails: undefined,
  indicator: undefined,
  cargas: undefined,
  usoSolo: undefined,
  agrotoxico: undefined,
  erosion: [],
  bovinesTotalSia: null,
  cargasUsoDoSolo: [],
  iceData: [],
  iceFirstAccess: true,
  restrictionData: [],
  restricoesAmbientais: [],
  saneparLocations: [],
  desmatamentosData: [],
};

const mutations = {
  setAccumulatedRainCurrentMonth(state, data){
    state.accumulatedRainCurrentMonth = data ? data : [];
  },
  setAccumulatedRainOfTheLastThirtyDays(state, data){
    state.accumulatedRainOfTheLastThirtyDays = data ? data : [];
  },
  setAccumulatedRainCurrentMonthSaic(state, data){
    state.accumulatedRainCurrentMonthSaic = data ? data : [];
  },
  setAccumulatedRainOfTheLastThirtyDaysSaic(state, data){
    state.accumulatedRainOfTheLastThirtyDaysSaic = data ? data : [];
  },

  setDailyEstimated(state, data) {
    state.siprecDailyEstimated = data ? data : [];
  },
  cleanDailyEstimated(state) {
    state.siprecDailyEstimated = [];
  },

  setMonthEstimated(state, data) {
    state.monthEstimated = data ? data : [];
  },
  cleanMonthEstimated(state) {
    state.monthEstimated = [];
  },

  setPrevHidroDaily(state, data) {
    state.prevHidroDaily = data ? data : [];
  },
  cleanPrevHidroDaily(state) {
    state.prevHidroDaily = [];
  },
  setPrevHidroMonth(state, data) {
    state.prevHidroMonth = data ? data : [];
  },
  cleanPrevHidroMonth(state) {
    state.prevHidroMonth = [];
  },

  setCompleteSeries(state, data) {
    state.completeSeries = data ? data : [];
  },
  cleanCompleteSeries(state) {
    state.completeSeries = [];
  },
  setGrantsEffluentsTotal(state, data) {
    state.grantsEffluentsTotal = data ? data : [];
  },
  cleanGrantsEffluentsTotal(state) {
    state.grantsEffluentsTotal = [];
  },
  setGrantsEffluents(state, data) {
    state.grantsEffluents = data ? data : [];
  },
  cleanGrantsEffluents(state) {
    state.grantsEffluents = [];
  },
  setSiaDetails(state, data) {
    state.siaDetails = data ? data : [];
  },
  cleanSiaDetails(state) {
    state.siaDetails = [];
  },
  setIndicator(state, data) {
    state.indicator = data ? data : [];
  },
  setIndicatorCarga(state, data) {
    state.cargas = data ? data : [];
  },
  setCargasUsoDoSolo(state, data) {
    state.cargasUsoDoSolo = data ? data : [];
  },
  setIndicatorErosion(state, data) {
    state.erosion = data ? data : [];
  },
  cleanIndicator(state) {
    state.indicator = [];
  },
  setUsoSolo(state, data) {
    state.usoSolo = data ? data : [];
  },
  cleanUsoSolo(state) {
    state.indicator = [];
  },
  setAgrotoxico(state, data) {
    state.agrotoxico = data ? data : [];
  },
  cleanAgrotoxico(state) {
    state.agrotoxico = [];
  },
  setIndicatorBovines(state, data) {
    state.bovinesTotalSia = data ? data : null;
  },
  setIndicatorIce(state, data) {
    state.iceData = data ? data : [];
  },
  setIceFirstAccess(state, data) {
    state.iceFirstAccess = data;
  },
  setIndicatorRestriction(state, data) {
    state.restrictionData = data ? data : [];
  },
  setRestricoesAmbientais(state, data) {
    state.restricoesAmbientais = data ? data : [];
  },
  setSaneparLocations(state, data) {
    state.saneparLocations = data ? data : [];
  },
  setDesmatamentosMensalData(state, data) {
    state.desmatamentosMensalData = data ? data : [];
  },
  setDesmatamentosData(state, data) {
    state.desmatamentosData = data ? data : [];
  },
  cleanDesmatamentosData(state) {
    state.desmatamentosData = [];
  },
};

const actions = {
  async loadAccumulatedRainCurrentMonth( {commit}, payload ){
    const {locationIds} = payload;
    let response;
    try{
      response = await loadSiprecAccumDaily(payload);
      commit('setAccumulatedRainCurrentMonth', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das informações de chuva acumulada para a localização de id: ${locationIds}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setAccumulatedRainCurrentMonth', undefined);
    }
  },

  async loadAccumulatedRainOfTheLastThirtyDays( {commit}, payload ){
    const {locationIds} = payload;
    let response;
    try{
      response = await loadSiprecAccumDaily(payload);
      commit('setAccumulatedRainOfTheLastThirtyDays', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das informações de chuva acumulada para a localização de id(s): ${locationIds}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setAccumulatedRainOfTheLastThirtyDays', undefined);
    }
  },

  async loadAccumulatedRainCurrentMonthSaic({commit}, payload ){
    const {locationIds} = payload;
    let response;
    try{
      response = await loadSiprecAccumDaily(payload);
      commit('setAccumulatedRainCurrentMonthSaic', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das informações de chuva acumulada SAIC para a localização de id: ${locationIds}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setAccumulatedRainCurrentMonthSaic', undefined);
    }
  },

  async loadAccumulatedRainOfTheLastThirtyDaysSaic( {commit}, payload ) {
    const {locationIds} = payload;
    let response;
    try{
      response = await loadSiprecAccumDaily(payload);
      commit('setAccumulatedRainOfTheLastThirtyDaysSaic', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Ocorreu um erro ao fazer a busca das informações de chuva acumulada SAIC para a localização de id: ${locationIds}.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setAccumulatedRainOfTheLastThirtyDaysSaic', undefined);
    }
  },


  cleanIndicatorBovines({commit}) {
    commit('setIndicatorBovines', null);
  },
  async loadCompleteSeries({commit}, payload) {
    const {stationId, sensorOperationListIds, type} = payload;
    const newPaylod = {stationId, sensorOperationListIds};
    try {
      if (type === 'mensal') {
        const response = await loadHydrologicalMonthlySummary(newPaylod);
        commit('setCompleteSeries', response); // por ser async, response será undefined
      } else if (type === 'diario') {
        const response = await loadHydrologicalDailySummary(newPaylod);
        commit('setCompleteSeries', response);
      } else if (type === 'horario') {
        const response = await loadHydrologicalHourlySummary(newPaylod);
        commit('setCompleteSeries', response);
      } else if (type === 'observado') {
        const {stationId, sensorListIds} = payload;
        const customPaylod = {stationId, sensorListIds};
        const response = await loadHydrologicalObserved(customPaylod);
        commit('setCompleteSeries', response);
      }
    } catch (error) {
      commit('setCompleteSeries', undefined);
    }
  },
  async loadSiprecDailyEstimated({commit}, payload) {
    try {
      const response = await loadSiprecDailyEstimated(payload);
      commit('setDailyEstimated', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das estimativas diárias.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setDailyEstimated', undefined);
    }
  },
  async loadPrevHidroDaily({commit}, payload) {
    try {
      const response = await loadPrevHidroDaily(payload);
      commit('setPrevHidroDaily', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das previsões hidrológicas diárias.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setPrevHidroDaily', undefined);
    }
  },
  async loadPrevHidroMonth({commit}, payload) {
    try {
      const response = await loadPrevHidroMonth(payload);
      commit('setPrevHidroMonth', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das previsões hidrológicas mensais.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setPrevHidroMonth', undefined);
    }
  },
  async loadMonthEstimated({commit}, payload) {
    try {
      const response = await loadMonthEstimated(payload);
      commit('setMonthEstimated', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das estimativas mensais.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setMonthEstimated', undefined);
    }
  },
  async loadOutorgasEfluentesTotal({commit}, payload) {
    try {
      const response = await loadOutorgasEfluentesTotal(payload);
      commit('setGrantsEffluentsTotal', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das outorgas totais dos efluentes.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setGrantsEffluentsTotal', undefined);
    }
  },
  async loadOutorgasEfluentes({commit}, payload) {
    try {
      const response = await loadOutorgasEfluentes(payload);
      commit('setGrantsEffluents', response.data[0]);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das outorgas efluentes.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setGrantsEffluents', undefined);
    }
  },
  async loadSiaDetails({commit}, payload) {
    try {
      const response = await loadSiaDetails(payload);
      commit('setSiaDetails', response.data[0]);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos detalhes da SIA.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSiaDetails', undefined);
    }
  },
  async loadIndicator({commit}, payload) {
    try {
      const response = await loadIndicator(payload);
      commit('setIndicator', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicator', undefined);
    }
  },

  async loadIndicatorCarga({commit}, payload) {
    try {
      const response = await loadIndicatorCarga(payload);
      commit('setIndicatorCarga', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores de cargas.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicatorCarga', undefined);
    }
  },

  async loadCargasUsoDoSolo({commit}, payload) {
    try {
      const response = await loadCargasUsoDoSolo(payload);
      commit('setCargasUsoDoSolo', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações da carga do uso do solo.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setCargasUsoDoSolo', undefined);
    }
  },

  async loadIndicatorBovinesSia({commit}, payload) {
    try {
      const response = await loadIndicatorBovinesSia(payload);
      commit('setIndicatorBovines', response.data[0].indbovino);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores dos bovinos SIA.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicatorBovines', null);
    }
  },

  async loadIndicatorErosionTotal({commit}, payload) {
    try {
      const response = await loadIndicator(payload);
      commit('setIndicatorErosion', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores totais de erosão.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicatorErosion', []);
    }
  },

  async loadIndicatorErosionSia({commit}, payload) {
    try {
      const response = await loadIndicatorErosion(payload);
      commit('setIndicatorErosion', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores totais de erosão SIA.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicatorErosion', []);
    }
  },

  async loadUsoSolo({commit}, payload) {
    try {
      const response = await loadUsoSolo(payload);
      commit('setUsoSolo', response.data[0]);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do uso do solo.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUsoSolo', undefined);
    }
  },
  async loadAgrotoxico({commit}, payload) {
    try {
      const response = await loadAgrotoxico(payload);
      commit('setAgrotoxico', response.data[0]);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos agrotóxicos.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setAgrotoxico', undefined);
    }
  },

  async loadIce({commit}, payload) {
    try {
      const response = await loadIndicatorIce(payload);
      commit('setIndicatorIce', response.data);
      commit('setIceFirstAccess', false);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do ICE.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicatorIce', []);
    }
  },

  async loadIndicatorRestriction({ commit }, payload) {
    try {
      const response = await loadIndicator(payload);
      commit("setIndicatorRestriction", response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores de restrições.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit("setIndicatorRestriction", []);
    }
  },

  async loadRestricoesAmbientais({ commit }, payload) {
    try {
      const response = await loadRestricoesAmbientais(payload);
      commit("setRestricoesAmbientais", response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das restrições ambientais.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit("setRestricoesAmbientais", []);
    }
  },

  async loadSaneparLocations({ commit }, payload) {
    try {
      const response = await loadSaneparLocations(payload);
      commit("setSaneparLocations", response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das localizações da Sanepar.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit("setSaneparLocations", []);
    }
  },

  async loadDesmatamentosData({commit}, payload) {
    const {sia, type} = payload;
    const newPaylod = {sia};
    try {
      if (type === 'anual') {
        const response = await loadDesmatamentosAnual(newPaylod);
        commit('setDesmatamentosData', response.data);
      }
      else if (type === 'mensal') {
        const response = await loadDesmatamentosMensal(newPaylod);
        commit('setDesmatamentosData', response.data);
      }
      else if (type === 'semestral') {
        const response = await loadDesmatamentosSemestral(newPaylod);
        commit('setDesmatamentosData', response.data);
      }
      else if (type === 'trimestral') {
        const response = await loadDesmatamentosTrimestral(newPaylod);
        commit('setDesmatamentosData', response.data);
      }

    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do desmatamento.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setDesmatamentosData', undefined);
    }
  },

};

const getters = {
  accumulatedRainCurrentMonth: (state) => state.accumulatedRainCurrentMonth,
  accumulatedRainOfTheLastThirtyDays: (state) => state.accumulatedRainOfTheLastThirtyDays,
  accumulatedRainCurrentMonthSaic: (state) => state.accumulatedRainCurrentMonthSaic,
  accumulatedRainOfTheLastThirtyDaysSaic: (state) => state.accumulatedRainOfTheLastThirtyDaysSaic,

  siprecDailyEstimated: (state) => state.siprecDailyEstimated,
  monthEstimated: (state) => state.monthEstimated,

  prevHidroDaily: (state) => state.prevHidroDaily,
  prevHidroMonth: (state) => state.prevHidroMonth,

  completeSeries: (state) => state.completeSeries,
  grantsEffluentsTotal: (state) => state.grantsEffluentsTotal,
  grantsEffluents: (state) => state.grantsEffluents,
  siaDetails: (state) => state.siaDetails,
  indicator: (state) => state.indicator,
  cargas: (state) => state.cargas,
  erosion: (state) => state.erosion,
  usoSolo: (state) => state.usoSolo,
  agrotoxico: (state) => state.agrotoxico,
  bovinesTotalSia: (state) => state.bovinesTotalSia,
  cargasUsoDoSolo: (state) => state.cargasUsoDoSolo,
  iceData: (state) => state.iceData,
  iceFirstAccess: (state) => state.iceFirstAccess,
  restrictionData: (state) => state.restrictionData,
  restricoesAmbientais: (state) => state.restricoesAmbientais,
  saneparLocations: (state) => state.saneparLocations,
  desmatamentosData: (state) => state.desmatamentosData,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
